import styled, { css } from "styled-components";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";
import {JACKPOT_STATE} from '../../../../../common/const/jackpot_map_ids';
import { JackpotThemeType } from "../../../../services/jackpots-with-state/jackpots-with-state.service.interface";
import {JACKPOT_WIDGET_LAYOUT} from "../../jackpot-widget.component";

interface IJackpotWidgetAmountBox {
    state: JACKPOT_STATE;
    layout: JACKPOT_WIDGET_LAYOUT;
    widgetWidth: number;
    themeType: JackpotThemeType;
}

const handleAmountBoxFontSize = (layout: JACKPOT_WIDGET_LAYOUT, widgetWidth: number, mAndBelow: boolean = false) => {
    switch (layout) {
        case JACKPOT_WIDGET_LAYOUT.LANDSCAPE:
        /** In desktop view at a widget width of 468px, the amount should be of font-size 35px */
            return widgetWidth * 35 / 468 + "px";
        case JACKPOT_WIDGET_LAYOUT.LANDSCAPE_WIDE:
        /** In minimized view at a widget width of 375px, the amount should be of font-size 16px */
            return widgetWidth * 16 / 375 + "px";
        case JACKPOT_WIDGET_LAYOUT.PORTRAIT:
        default:
            if (mAndBelow) {
                /** In mobile view at a widget width of 131px, the amount should be of font-size 16px */
                return widgetWidth * 16 / 131 + "px";
            } else {
                /** In mobile view at a widget width of 131px, the amount should be of font-size 19px */
                return widgetWidth * 19 / 131 + "px";
            }
    }
};

const JackpotWidgetAmountDefaultBox = styled.div<IJackpotWidgetAmountBox>`
    text-align: center;
    width: 100%;
    color: ${({state, theme}) => state === JACKPOT_STATE.Cold ? theme.colors.textLight : theme.colors.brandSecondary };
    text-shadow: 0px 2px 3px ${({theme}) => theme.colors.backgroundMiddleDark};
    /* font-preset: a standardized combination of font-family + font-weight + font-style + font-stretch */
    ${({state, theme}) => state === JACKPOT_STATE.Cold ? theme.font.presets.bold : theme.font.presets.black }
    ${({state}) => state === JACKPOT_STATE.Cold ? css`
        opacity: 0.8;
    ` : null };
    font-size: ${({layout, widgetWidth}) => handleAmountBoxFontSize(layout, widgetWidth)};
    /* bugfix: 2039067 */
    padding-bottom: 0.8rem;
    line-height: 1.2;

    @media ${({theme}) => theme.mediaQuery.mAndBelow} {
        font-size: ${({layout, widgetWidth}) => handleAmountBoxFontSize(layout, widgetWidth, true)};
    }
`;

const JackpotWidgetAmountCasino777Box = styled(JackpotWidgetAmountDefaultBox)`
    color: ${({state, theme, themeType}) => (themeType === JackpotThemeType.Light ? (state === JACKPOT_STATE.Cold ? theme.colors.textContrast : theme.colors.danger) : theme.colors.brandSecondary) };
    text-shadow: none;
`;

const JackpotWidgetAmountSiBox = styled(JackpotWidgetAmountDefaultBox)`
    color: ${({theme}) => theme.colors.moneyColor };
    text-shadow: none;
`;

export const JackpotWidgetAmountBox = styledByTheme(JackpotWidgetAmountDefaultBox)
    .forCasino777(JackpotWidgetAmountCasino777Box)
    .forSI(JackpotWidgetAmountSiBox)
    .forSICis(JackpotWidgetAmountSiBox)
    .apply();
